export default __webpack_public_path__ + "static/media/materialdesignicons-webfont.7a50c73b.eot";